// extracted by mini-css-extract-plugin
module.exports = {"header_logo":"Storelogo_header_logo__1nObG"};